import MuiList, { ListProps as MuiListProps } from '@mui/material/List';
import MuiListSubheader from '@mui/material/ListSubheader';
import * as React from 'react';

import { ListItem, ListItemProps } from './list-item';

export { ListItem } from './list-item';
export type { ListItemProps } from './list-item';
export { SearchListItem } from './search-list-item';
export type { SearchListItemProps } from './search-list-item';

export interface ListProps<R = undefined> extends MuiListProps {
    item?: R;
    width?: number;
    height?: number;
    items?: ListItemProps<R>[];
    footer?: React.ReactNode;
    children?:
        | React.ReactElement<ListItemProps<R>>[]
        | React.ReactElement<ListItemProps<R>>;
}

export const List = <R,>(props: ListProps<R>) => {
    const {
        items = [],
        sx,
        subheader,
        footer,
        width,
        height,
        children,
        ...muiProps
    } = props;

    if (items?.length && children) {
        console.warn(
            'List component should not have both items and children defined. Please use one or the other.'
        );
    }

    return (
        <MuiList
            sx={{
                width: width ?? '100%',
                height,
                overflow: 'auto',
                overscrollBehavior: 'contain',
                borderRadius: 1,
                ...(footer ? { pb: 0 } : {}),
                ...sx
            }}
            subheader={
                subheader && (
                    <MuiListSubheader data-role="subheader">
                        {subheader}
                    </MuiListSubheader>
                )
            }
            {...muiProps}
        >
            {items.length > 0
                ? items.map((itemProps, i) => (
                      <ListItem key={i} {...itemProps} />
                  ))
                : children}
            {footer && (
                <MuiListSubheader
                    data-role="footer"
                    sx={{ display: 'flex', minHeight: 48, bottom: 0, px: 0 }}
                >
                    {footer}
                </MuiListSubheader>
            )}
        </MuiList>
    );
};
